import React from "react";
import AppLoader from "../Common/AppLoader";

const MobileLeadCards=({ leads=[], loading, navigate, selectedLeadIds=[], handleLeadSelect, hideCheckbox=false, })=>{

  if(loading){
    return (
      <div className="text-center py-5">
        <AppLoader/>
      </div>
    );
  }

  if(!leads.length){
    return (
      <div className="text-center py-5">
        No Leads Found
      </div>
    );
  }

  return (
    <div className="mobile-leads-list">

      {leads.map((l,index)=>(
        <div
          key={l._id}
          className="mobile-lead-card"
          onClick={() => navigate(`/lead-details/${l.source}/${l._id}`)}
        >

          <div className="mobile-lead-header">

            {
              !hideCheckbox && (
                <label
                  className={`crm-checkbox ${
                    selectedLeadIds.includes(l._id)
                      ? "active"
                      : ""
                  }`}
                  onClick={(e)=>{
                    e.stopPropagation();
                    handleLeadSelect(l)
                  }}
                >
                  <span />
                </label>
              )
            }

            <div className="flex-grow-1">

              <div className="mobile-lead-id">
                #{index + 1}
              </div>

              <h5 className="mobile-lead-name">
                {l.name || "-"}
              </h5>

            </div>

            <i className="mdi mdi-chevron-right text-muted fs-4" />

          </div>

          <div className="mobile-lead-contact">

            {l.email && (
              <div>
                <i className="mdi mdi-email-outline me-1" />
                {l.email}
              </div>
            )}

            {l.phone && (
              <div>
                <i className="mdi mdi-phone-outline me-1" />
                {l.phone}
              </div>
            )}

          </div>

          <div className="mobile-lead-info">

            <div>
              <span className="text-muted">
                Project :
              </span>{" "}
              {l.projectName || "-"}
            </div>

            <div>
              <span className="text-muted"> Source : </span>{" "}
              {l.source === "google" ? (
                <span className="d-inline-flex align-items-center text-warning fw-semibold">
                  <i className="mdi mdi-google me-1" />
                  Google
                </span>
              ) : l.source === "facebook" ? (
                <span>
                  <span className="d-inline-flex align-items-center text-info fw-semibold">
                    <i className="mdi mdi-facebook me-1" />
                    Facebook
                  </span>
                  <br />
                  <small className="text-muted"> {l.formName || "-"} </small>
                  <br />
                  <span className="badge bg-primary mt-1"> {l.pageName || "-"} </span>
                </span>
              ) : (
                <span>
                  <span className="d-inline-flex align-items-center text-success fw-semibold">
                    <i className="mdi mdi-account-plus-outline me-1" />
                    {l.source === "generic" ? "Generic Lead" : String(l.source).toUpperCase()}
                  </span>
                  <br />
                  <span className="badge bg-soft-info text-info mt-1"> Manual / Import </span>
                </span>
              )}

            </div>

            <div>
              <span className="text-muted">
                Assigned :
              </span>{" "}
              {l.assignedTo || "-"}
            </div>

          </div>

          <div className="mobile-lead-footer">

            <div className="d-flex align-items-center gap-1">
              <span className="badge bg-primary">
                {l.stage || "-"}
              </span>
              {l.remark && (
                <span className="badge bg-warning text-dark">
                  {l.remark}
                </span>
              )}
            </div>

            <small className="text-muted">
              {
                l.createdTime
                  ? new Date(l.createdTime).toLocaleString(
                      "en-GB",
                      {
                        day:"2-digit",
                        month:"short",
                        year:"numeric",
                        hour:"2-digit",
                        minute:"2-digit",
                      }
                    )
                  : "-"
              }
            </small>

          </div>

        </div>
      ))}

    </div>
  );
};

export default MobileLeadCards;